module.exports = __webpack_public_path__ + "static/media/bg-gray-additional.f6cc7974.jpg";